import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import CloseButton from '@material-ui/icons/Close'
import MapboxGl from 'mapbox-gl'
import React, { useContext, useEffect } from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - FIXME (tchow 2025/03/12): Remove current comment when upgrading to react 19
import { createRoot } from 'react-dom/client'

import { MapContext } from './index'

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    closeButton: {
      alignSelf: 'end',
      height: '20px',
      marginBottom: '-20px',
      zIndex: 2, // above the Mapbox layers so we can click on the close button
      fontSize: 18,
      cursor: 'pointer',
    },
    mapPopupInvisible: {
      opacity: 0,
    },
    mapPopupVisible: {
      opacity: 1,
    },
  })

interface IProps extends WithStyles<typeof styles> {
  children: React.ReactNode
  closeButton?: boolean
  coordinates: MapboxGl.LngLat
  horizontalOffset?: number
  verticalOffset?: number
}
const MapPopup = ({
  classes,
  children,
  coordinates,
  horizontalOffset = 0,
  verticalOffset = 0,
  closeButton = true,
}: IProps) => {
  let popUp: MapboxGl.Popup | undefined = undefined
  const map = useContext(MapContext)

  const onCloseClick = () => {
    if (popUp && popUp.isOpen) {
      popUp.remove()
    }
  }

  const renderCloseButton = () => {
    return <CloseButton className={classes.closeButton} onClick={onCloseClick} />
  }

  useEffect(() => {
    if (map) {
      const content = document.createElement('div')
      const root = createRoot(content)
      root.render(
        <div className={classes.root}>
          {closeButton && renderCloseButton()}
          {children}
        </div>,
        content
      )
      popUp = new MapboxGl.Popup({
        maxWidth: 'none',
        closeButton: false,
        className: classes.mapPopupInvisible,
        offset: [horizontalOffset, verticalOffset],
      })
        .setLngLat(coordinates)
        .setDOMContent(content)
        .addTo(map)
      // when popup is opened near the borders, it won't always open itself within the borders.
      // This hack is to force it to replace itself within while it is invisible
      // and without the zoom being noticeable, and then make it visible.
      const zoom = map.getZoom()
      setTimeout(() => {
        map.setZoom(zoom) // no-change zoom, but popup will reposition itself.
        const container = document.querySelectorAll(`div[class*=${classes.mapPopupInvisible}`)
        if (container.length > 0) {
          container.item(0).classList.add(classes.mapPopupVisible)
        } else {
          console.error('Cannot display vehicle popup.')
        }
      }, 1)
    }

    // Before we create a new MapboxGl.Popup instance, we need to remove it if any.
    return () => {
      if (popUp) {
        popUp.remove()
      }
    }
  }, [coordinates])
  return null
}

export default withStyles(styles)(MapPopup)
